'use client';

import { SectionContainer } from '@/components/ui';
import { Skeleton } from '@/components/ui/Skeleton';

export function ConstructionSectionSkeleton() {
  return (
    <SectionContainer>
      <Skeleton className="h-7 w-80 mb-2" />
      <Skeleton className="h-5 w-96 mb-4" />

      <div className="mt-4 space-y-0">
        {/* Major Projects Skeleton */}
        <div className="flex items-start gap-3 p-4 rounded-lg">
          <Skeleton className="w-6 h-6 shrink-0" />
          <div className="flex-1">
            <div className="flex items-center justify-between gap-2 mb-1">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="w-3 h-3 shrink-0" />
            </div>
            <Skeleton className="h-4 w-full" />
          </div>
        </div>

        <div className="border-b border-tertiary my-2" />

        {/* Minor Projects Skeleton */}
        <div className="flex items-start gap-3 p-4 rounded-lg">
          <Skeleton className="w-6 h-6 shrink-0" />
          <div className="flex-1">
            <div className="flex items-center justify-between gap-2 mb-1">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="w-3 h-3 shrink-0" />
            </div>
            <Skeleton className="h-4 w-full" />
          </div>
        </div>
      </div>
    </SectionContainer>
  );
}
